import { gql } from '@apollo/client';

export const CampaignSummaryQuery = gql`
  query CampaignSummary($campaignId: ID!) {
    campaign(id: $campaignId) {
      id
      shortId
      name
      brand {
        name
        company {
          id
          name
        }
      }
    }
  }
`;

export const CompanyIdByCampaignQuery = gql`
  query CompanyIdByCampaign($campaignId: ID!) {
    campaign(id: $campaignId) {
      id
      companyId
      status
    }
  }
`;

export const ExternalCampaignQuery = gql`
  query ExternalCampaign($campaignId: ID!) {
    externalCampaign(campaignId: $campaignId) {
      name
      campaignId
      status
      campaignType
      agentName
      createdAt
      hasActivity
      setupChecklist {
        key
        complete
      }
    }
  }
`;
